import React from 'react'
import { alert } from 'notie'
import { connect } from 'react-redux'

class Notify extends React.Component {
  componentWillReceiveProps(nextProps) {
    const { time } = this.props;
    const { notification } = nextProps;
    
    if (notification.msg && notification.type) {
      alert(Object.assign({
        type: notification.type,
        text: notification.msg,
        position: 'bottom'
      }, {
        time: time || 3,
      }))
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => ({
  notification: state.notification
});

export default connect(mapStateToProps)(Notify);



// WEBPACK FOOTER //
// ./src/components/ui/Notify/index.jsx